module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_1f2a04a.png";